import thunk from 'redux-thunk'
import promiseMiddleware from 'redux-promise'
import { createStore, applyMiddleware, compose } from 'redux'

import createReducer from './reducers'
import apiMiddleware from './middlewares/api'

const initStore = (initialState = {}, asyncReducers = {}) => {
  const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose

  const middlewares = [ promiseMiddleware, thunk, apiMiddleware ]

  const store = createStore(createReducer(asyncReducers), initialState, composeEnhancers(
    applyMiddleware(...middlewares)
  ))

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./reducers', () => {
      const nextRootReducer = require('./reducers/index')(asyncReducers)
      store.replaceReducer(nextRootReducer)
    })
  }

  store.asyncReducers = asyncReducers

  return store
}

export const injectAsyncReducer = (store, reducers = {}) => {
  Object.keys(reducers).map(name => {
    store.asyncReducers[name] = reducers[name]
    return null
  })

  store.replaceReducer(createReducer(store.asyncReducers))
}

export default initStore



// WEBPACK FOOTER //
// ./src/store/index.js